export default __webpack_public_path__ + "static/media/3117.967a0c20.jpg";